import React from 'react';
import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { StockCardCategoriesComponent } from '../../../../generated/graphql';
import { NoContent } from '../../../../ui-kit';
import WarehouseCategoriesListView from './WarehouseCategoriesListView';

const WarehouseCategoriesList = () => {
    const { t } = useTranslation();
    const noCategoriesTitle = t('No category created');
    return (
        <StockCardCategoriesComponent>
            {({ data: { stockCardCategories } }) => isEmpty(stockCardCategories)
                ? <NoContent title={noCategoriesTitle} />
                : <WarehouseCategoriesListView stockCardCategories={stockCardCategories} />}
        </StockCardCategoriesComponent>
    );
};

export default WarehouseCategoriesList;